<template>
    <div class="pagina page-index d-flex flex-column justify-content-between">
        <header>
            <div class="container-fluid">
                <div class="brand-logos">
                    <a class="navbar-brand" href="/">
                        <img :src="require('@/assets/css/img/logo.png')" class="logo" />
                    </a>
                </div>
            </div>
        </header>
        <main>
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 d-flex flex-column justify-content-center mb-2">
                        <h1 class="h1-index">Programa de Vacaciones</h1>
                        <span class="year">{{ ano }}</span>
                    </div>
                    <div class="col-lg-4">
                        <div class="card-login p-4">
                            <h3 class="mb-3">Acceso Agencias</h3>

                            <b-form>
                                <b-form-group class="pt-2"
                                    label="Usuario / Agencia" label-for="user"
                                    v-bind="attr_user">
                                    <b-input-group class="my-2">
                                        <b-form-input type="text" id="user" ref="user"
                                            v-model="user.user" trim
                                            v-bind="attr_user">
                                        </b-form-input>
                                        <!-- <b-input-group-prepend is-text><b-icon-person-fill/></b-input-group-prepend>                    -->
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group
                                    label="Contraseña / Password" label-for="pass">
                                    <b-input-group class="my-2">
                                        <b-form-input type="password" id="pass" ref="pass"
                                            v-model="user.pass"
                                            v-bind="attr_pass"
                                            @keypress.13="check">
                                        </b-form-input>
                                        <!-- <b-input-group-prepend is-text><b-icon-eye @click="alert('aa')"/></b-input-group-prepend> -->
                                    </b-input-group>
                                </b-form-group>

                                <div class="text-center">
                                    <p class="mt-3">
                                        <a href="#" class="mr-2" @click="olvidar">¿Olvidó su contraseñaa?</a>
                                    </p>
                                    <button type="button" class="btn btn-primary"
                                        data-toggle="modal" data-target="#response"
                                        @click.prevent="check">
                                        Acceder
                                    </button>
                                </div>
                                <div class="text-center mt-2">
                                    <small>v{{ version }}</small>
                                </div>
                            </b-form>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <div><AppFooter/></div>

    </div>
</template>

<script>

import AppFooter from '@/components/AppFooter.vue'

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'home',
  components: { //login,
    AppFooter,
  },
  data() {
    return {
        cierre: false,

        ano: '2021',

        user: { user:'', pass:'', error: '', logU: false, logP: false, sid: '' },
        error: { error: false, msg: '', title:'' },
    }
  },

  created() {
    if (this.cierre) { this.cerrado(); return; }

    if (this.logueado) {
      if (this.$route.name=='home')
        this.$router.push('/entrada');
      else
        this.$bvModal.hide("modal_login");
    }

    //año
    this.ano=new Date().getFullYear();
  },

  computed: {
    ...mapState(['auth','errores']),

    logueado() {
      return this.auth.logueado;
    },
    usuario() {
        return this.$store.state.auth.user;
    },
    version() {
        return process.env.VUE_APP_VERSION;
    },

    // atributos usuario / acceso
    attr_user() {
      //if (this.user.logU) return {state: true, disabled: false, "valid-feedback": "USUARIO REGISTRADO" };
      //if (this.user.error) return {state: false, disabled: false, "invalid-feedback": this.user.error };
      return { disabled: false};
    },
    attr_pass() {
      return { disabled: false};
    },
    // texto boton
    btn_login() {
      return "ACCEDER"; //(!this.user.logU ? "CONTINUAR" : "CONECTARSE");
    }

  },

  methods: {
    ...mapMutations(['loading','alerta','modal']),
    ...mapActions(['exec']),

    cerrado() {
        let m="Estamos elaborando los Programas de Vacaciones para la próxima temporada.<br><br><u>Por favor, vuelve a visitarnos un poco más adelante.";
        this.modal({tit:"Información", msg: m});
    },

    check() {
        if (this.cierre) { this.cerrado(); return; }

        let u=this.user.user;
        let p=this.user.pass;
        let t=this.auth.token;

        if (u==='') { this.user.error="Debes Introducir un Usuario"; return; }
        if (p==='') { this.user.error="Debes Introducir una Contraseña"; return; }

        let args={user: u, token: t, pass:p};
        this.login(args);
    },

    async login(args) {
        //this.loading();
        let r=await this.exec({api:'login', arg:args});
        this.login_back(r);
    },

    login_back(r) {
      this.user.error="";
      let m='';
      //////////////////////////////////////////////si error
       if (r.error) {
            if (r.datos=='101') { this.cerrado(); return; } else
            if (r.datos=='102') m="Sistema en Administración. Disculpe las molestias"; else
            m="Contraseña / Password Incorrecta";
            this.user.error=m;
            this.modal({tit:"Informacion", msg: this.user.error});
            this.$refs.pass.focus();
            return;
        }


        this.$store.commit('login_back',r);
        this.$router.push('/hoteles');
    },

    olvidar() {
        //if (this.cierre) { this.cerrado(); return; }

        let m="Debe contactar con nostros en el Teléfono 950 627 019.";
        this.modal({tit:"Login/Acceso", msg: m});

    },
  },

}
</script>
